import { render, staticRenderFns } from "./sendKami.vue?vue&type=template&id=497da276&scoped=true"
import script from "./sendKami.vue?vue&type=script&lang=js"
export * from "./sendKami.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497da276",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('497da276')) {
      api.createRecord('497da276', component.options)
    } else {
      api.reload('497da276', component.options)
    }
    module.hot.accept("./sendKami.vue?vue&type=template&id=497da276&scoped=true", function () {
      api.rerender('497da276', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/supplierOrder/sendKami.vue"
export default component.exports